import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdatePositionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import DictionarySelector from '../Selects/DictionarySelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { TooltipKey } from '../../../common/pokCore/tooltip.enum';

interface PositionContractNotRequiredFieldsProps {
  position: CreateUpdatePositionDto;
  propertyChange: (obj: Partial<CreateUpdatePositionDto>) => void;
}

export const PositionContractNotRequiredFields: React.FC<
  PositionContractNotRequiredFieldsProps
> = props => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <>
      <FormRow
        controlId="contractNotRequired"
        label={t(tk.position.contractNotRequired)}
        tooltipKey={TooltipKey.positionContractNotRequiredTooltip}
      >
        <Form.Check
          type="checkbox"
          className="pt-2"
          checked={props.position.contractNotRequired ?? false}
          onChange={e =>
            props.propertyChange(
              e.target.checked
                ? { contractNotRequired: true }
                : {
                    contractNotRequired: false,
                    contractNotRequiredBasisDictionaryId: null,
                    contractNotRequiredDescription: null,
                  },
            )
          }
        />
      </FormRow>
      {props.position.contractNotRequired && (
        <>
          <FormRow
            controlId="contractNotRequiredBasisDictionaryId"
            label={t(tk.position.contractNotRequiredBasis)}
            tooltipKey={TooltipKey.positionContractNotRequiredBasisTooltip}
          >
            <DictionarySelector
              dictionary="Podstawa braku zlecenia"
              value={
                props.position.contractNotRequiredBasisDictionaryId ?? undefined
              }
              onChange={option =>
                props.propertyChange({
                  contractNotRequiredBasisDictionaryId: option.value || null,
                })
              }
            />
          </FormRow>
          <FormRow
            controlId="contractNotRequiredDescription"
            label={t(tk.position.contractNotRequiredDescription)}
            tooltipKey={
              TooltipKey.positionContractNotRequiredDescriptionTooltip
            }
          >
            <Form.Control
              type="text"
              value={props.position.contractNotRequiredDescription || ''}
              onChange={e =>
                props.propertyChange({
                  contractNotRequiredDescription: e.target.value || null,
                })
              }
            />
          </FormRow>
        </>
      )}
    </>
  );
};
